export default function DarkMeshBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
      aria-hidden
    >
      {/* mesh layer */}
      <div className="absolute inset-0 bg-mesh-dark animate-mesh-drift opacity-80" />
      <div className="absolute inset-0 v2-grid-pattern opacity-60" />
      <div className="absolute top-1/4 right-0 w-72 h-72 md:w-96 md:h-96 translate-x-1/3 rounded-full bg-teal-500/20 blur-[120px] animate-glow-pulse" />
      <div className="absolute bottom-1/4 left-0 w-64 h-64 md:w-80 md:h-80 -translate-x-1/3 rounded-full bg-cyan-500/15 blur-[100px] animate-glow-pulse [animation-delay:2s]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-aait-primary/5 blur-[150px]" />
    </div>
  );
}
